import { getRem } from './getRem';

export function getArrayRem(value?: (string | number)[]) {
  if (!value) return null;

  return value
    .reduce((result, item) => `${result} ${getRem(item)}`, '')
    .toString()
    .trim();
}
